import { render, staticRenderFns } from "./AssetAssignmentNew.vue?vue&type=template&id=6974b30c"
import script from "./AssetAssignmentNew.vue?vue&type=script&lang=js"
export * from "./AssetAssignmentNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports